var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8797 11.4176V33.6638M20.8797 11.4176C18.881 10.0897 16.167 9.27344 13.1791 9.27344C10.1913 9.27344 7.47725 10.0897 5.47852 11.4176V33.6638C7.47725 32.3359 10.1913 31.5196 13.1791 31.5196C16.167 31.5196 18.881 32.3359 20.8797 33.6638M20.8797 11.4176C22.8785 10.0897 25.5925 9.27344 28.5803 9.27344C31.5699 9.27344 34.2822 10.0897 36.2809 11.4176V33.6638C34.2822 32.3359 31.5682 31.5196 28.5803 31.5196C25.5925 31.5196 22.8785 32.3359 20.8797 33.6638",
    stroke: "#2C4657",
    strokeWidth: 3.42249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSvg);
export default __webpack_public_path__ + "static/media/book-svg.df21303eee5684b9ed4e7bc6f7e4e362.svg";
export { ForwardRef as ReactComponent };